import React, { FC } from 'react';
import { useController, UseControllerProps } from 'react-hook-form';
import { DatePicker, handleYearInput } from '@common/datePicker';
import styles from '@common/inputFields/inputFields.module.scss';

import DateFormat from '@utils/date/format';
import classnames from 'classnames/bind';
const cx = classnames.bind(styles);

interface BirthDateProps extends UseControllerProps {
  resetValue?: string | null;
  maxDate?: Date;
  placeholderText?: string;
}

const BirthDate: FC<BirthDateProps> = (props) => {
  const { resetValue, maxDate, placeholderText } = props;
  const { field, fieldState } = useController(props);

  const selected = field.value ? new Date(field.value) : null;
  const birthDateInputComplete = !!field.value;
  const isError = fieldState.invalid;

  const handleChange = (date: Date | null) => {
    if (date) field.onChange(DateFormat.format(date, 'yyyy-MM-dd'));
    else field.onChange('');
  };

  const onBlur = () => {
    if (!field.value) field.onChange(resetValue);
  };

  return (
    <div className={cx('birthdayArea')} onBlur={onBlur}>
      <DatePicker
        selected={selected}
        onChange={handleChange}
        onChangeRaw={handleYearInput}
        className={cx('input', { error: isError }, { complete: birthDateInputComplete })}
        placeholderText={placeholderText || '생년월일'}
        maxDate={maxDate || new Date('9999-12-31')}
      />
      {isError && <div className={cx('errorMessage')}>{fieldState.error?.message}</div>}
    </div>
  );
};

export default BirthDate;
